// Sensitive object keys that must never be logged to raygun. Shared by the client and ionic
// reporters (raygun's filterSensitiveData) and by redactSensitiveData in raygun-axios-custom-data.js.
//
// Entries are regexes so matching is case-insensitive (raygun4js string filters are case-sensitive)
// and stem-based — one pattern covers every casing/variant of a family, including response keys that
// differ from the underlying model field name (e.g. the 2FA setup returns the secret as `secret`).
//
// Scope: secrets, tokens and payment data only. Plain PII (email/phone/address/signature) is left
// intact — email in particular is the raygun user identifier and a key debugging signal.
//
// NOTE: the server reporter (servsrc/lib/raygun/raygun-client.js) keeps its own EXACT-string list
// because the raygun node SDK matches filter keys with indexOf (no regex). Keep the two in sync.
const SENSITIVE_KEYS = [
  /password/i, // password, oldPassword, passwordHash
  /token/i, // token, access_token, refresh_token, authToken, uploadToken,
  //           confirmationToken, accountconfirmationtoken, auth_token_restricted, apitoken
  /secret/i, // secret (2FA QR response), clientSecret, twoFactorAuthSecret
  /^totp$/i,
  /recoveryCode/i,
  /^base32/i, // base32, base32Unconfirmed
  /^cvc$/i,
  /^cvv$/i,
  /iban/i,
  /credit_?card/i, // credit_card, creditcard
  /^paymentMethodId$/i,
  /^stripe/i, // stripeCustomerId, stripeSubscriptionId, stripePaymentMethodId
  /^billingaddress$/i,
  /additionalInvoiceInformation/i,
]

// Matches one key against the list above. Exported so every reporter-side redactor (the axios custom
// data and the breadcrumb redactor) answers "is this sensitive?" the same way raygun's own filter does.
export const isSensitiveKey = (key) =>
  SENSITIVE_KEYS.some((matcher) => (matcher instanceof RegExp ? matcher.test(key) : matcher === key))

export default SENSITIVE_KEYS
